import Sheep from '@/plugins/sheep/Sheep'

export function install (Vue) {
  Object.defineProperty(Vue.prototype, '$sheep', { value: new Sheep() })
}

export default Sheep
